const paymentRo = {
    "billing": {
        "name": "Nume/Numele companiei",
        "country": "Ţară",
        "postal_code": "Cod poștal",
        "city": "Oraş",
        "address": "Adresa",
        "tax_number": "Cod fiscal",
        "phone": "Număr de telefon",
        "tax_number_helper_text": "Obligatoriu pentru companii, nu pentru persoane fizice",
        "billing_info": "Informații de facturare",
        "emails_helper_text": "Opțional. Pentru adrese de e-mail multiple, separați-le prin virgule."
    },
    "subscription_plans": {
        "PRO": "Planul Pro",
        "FREE": "Plan gratuit"
    },
    "plan_descriptions": {
        "PRO": "Pentru restaurantele care doresc să-și ducă afacerea la nivelul următor! Traduceți meniul în limbi noi cu doar câteva clicuri, cereți feedback oaspeților despre preparatele lor, urmăriți utilizarea codului QR în meniu cu statistici utile sau permiteți QuickPick AI să răspundă automat la feedback-ul oaspeților în stilul dumneavoastră!",
        "FREE": "Pentru restaurantele care doresc să înceapă să utilizeze meniuri online și coduri QR."
    },
    "subscription_status": {
        "ACTIVE": "Activ",
        "CANCELLED": "Anulat"
    },
    "next_billing_date": "Următoarea dată de facturare",
    "current_subscription": "Abonament curent",
    "cancel": "Anula",
    "subscription_interval_prices": {
        "MONTHLY": "lună",
        "YEARLY": "an",
        "HALF_YEARLY": "jumătate de an",
        "QUARTERLY": "trimestru"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Abonament lunar",
        "YEARLY": "Abonament anual",
        "HALF_YEARLY": "Abonament de jumătate de an",
        "QUARTERLY": "Abonament trimestrial"
    },
    "reactivate": "Reactiva",
    "valid_to": "Valabil până la",
    "payments_and_invoices": "Plăți și facturi",
    "amount": "Cantitate",
    "invoice": "Factura",
    "update_card": "Actualizare",
    "payment_method": "Modalitate de plată",
    "cancel_subscription_confirmation": "Sigur vrei să anulezi abonamentul curent?",
    "cancel_subscription_valid_until": "Abonamentul va rămâne valabil până la data următoare",
    "subscription_cancelled": "Abonamentul a fost anulat cu succes",
    "reactivate_confirmation": "Sigur vrei să reactivezi abonamentul anulat?",
    "reactivate_successful": "Abonamentul a fost reactivat cu succes",
    "change_payment_method": "Schimbați metoda de plată",
    "change_payment_method_tooltip": "Pentru a modifica detaliile de plată, trebuie să plătiți pentru următoarea perioadă de abonament. Desigur, abonamentul dvs. va fi prelungit cu durata perioadei, iar următoarea dată de facturare va fi scadentă cu aceeași oră mai târziu.",
    "amount_to_be_paid": "Sumă de plătit",
    "new_subscription_valid_until": "Valabilitatea noului abonament",
    "bank_card_expires_soon": "Cardul bancar folosit pentru abonament va expira în curând.",
    "reactivate_subscription_confirmation": "Sigur vrei să reactivezi abonamentul anulat?",
    "billing_information": "Informații de facturare",
    "edit_billing_information": "Editați informațiile de facturare",
    "no_available_invoices": "Nu sunt disponibile facturi",
    "subscribe": "Abonează-te",
    "continue_to_payment": "Continuați cu plata",
    "confirm_subscription": "Confirmați abonamentul",
    "subscription_page_title": "Începeți abonamentul",
    "pay": "Plată",
    "available_plans": "Abonament disponibil",
    "accept_terms_and_conditions": "Am citit și accept <a>Termenii și condițiile</a>",
    "accept_recurring_payments": "Prin plată, accept debitarea automată a plăților recurente, pe care o pot anula oricând.",
    "accept_privacy_policy": "Am citit și accept <a>Politica de confidențialitate</a>",
    "subscribe_soon": "În curând"
};

export default paymentRo;
